<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <div class="divider"><span>Especificações</span></div>

    <div class="l-row">
      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['color']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['size']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('crossDocking') !== -1" :label="$t(`crossDocking.label`)" :columns="3" :error="getError('attributes.crossDocking', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['crossDocking']" :disabled="disabledInputs()">
      </form-group>
    </div>

  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {},
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?1bfbe02e